import { render } from "./MenuIcon.vue?vue&type=template&id=6bf2bc6e"
const script = {}

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__